import { PhotoReviewPage } from './PhotoReviewPage';

export const photoReviewRouter = {
  '/@/communities': PhotoReviewPage,
};
